import { render, staticRenderFns } from "./SwitchLanguage.vue?vue&type=template&id=92015982&"
import script from "./SwitchLanguage.vue?vue&type=script&lang=js&"
export * from "./SwitchLanguage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports